export default
    {
        path: "/carteenHome",
        component: () => import('../view/carteen/carteen.vue'),
        children: [
            {
                path: "",
                name: '',
                component: () => import('../view/carteen/home.vue'),
                props: (route) => (
                    {
                        token: route.query.token,
                        deviceType: route.query.deviceType,
                        userId: route.query.userId,
                        uid: route.query.uid,
                        secondLoginType:route.query.secondLoginType,
                        secondAssessToken:route.query.secondAssessToken,
                        deviceId:route.query.deviceId,
                    }
                ),
            },
            {
                path: "detail",
                name: 'detail',
                component: () => import('../view/carteen/detail.vue'),
                props: (route) => (
                    {
                        uid: route.query.uid,
                        xwuid: route.query.xwuid
                    }
                )
            }
        ]

    }



// WEBPACK FOOTER //
// ./src/router/carteenRouter.js